var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEllipses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 6.75C7.75725 6.75 6.75 7.75725 6.75 9C6.75 10.2427 7.75725 11.25 9 11.25C10.2427 11.25 11.25 10.2427 11.25 9C11.25 7.75725 10.2427 6.75 9 6.75ZM2.25 6.75C1.00725 6.75 0 7.75725 0 9C0 10.2427 1.00725 11.25 2.25 11.25C3.49275 11.25 4.5 10.2427 4.5 9C4.5 7.75725 3.49275 6.75 2.25 6.75ZM15.75 6.75C14.5073 6.75 13.5 7.75725 13.5 9C13.5 10.2427 14.5073 11.25 15.75 11.25C16.9927 11.25 18 10.2427 18 9C18 7.75725 16.9927 6.75 15.75 6.75Z",
    fill: "#5F698B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEllipses);
export default __webpack_public_path__ + "static/media/icon_ellipses.b8ef5572bb607162d135d1ded0b4c155.svg";
export { ForwardRef as ReactComponent };